import React from 'react'
import _ from 'lodash'

import InputGroup from '../../atoms/InputGroup'
import Loading from '../../atoms/Loading'

export default class CheckboxGroup extends React.PureComponent {
  static defaultProps = {
    items: [],
    loading: false,
    onChange: null,
    value: []
  }

  isValueSelected = (value) => {
    if (value !== 'all') {
      return this.props.value.some((v) => (v == value));
    } else {
      return this.hasAllValues();
    }
  }

  hasAllValues = () => {
    const itemsValues = _.map(this.props.items, 'value');

    return _(itemsValues)
      .map((item) => {
        return _.includes(this.props.value, item);
      })
      .compact()
      .value().length === itemsValues.length;
  }

  handleCheckboxClick(value) {
    if (value !== 'all') {
      if (this.isValueSelected(value)) {
        this.props.onChange(
          this.props.value.filter((selectedValue) => (
            value != selectedValue
          ))
        )
      } else {
        this.props.onChange(
          this.props.value.concat(value)
        )
      }
    } else {
      if (this.hasAllValues()) {
        this.props.onChange(
          []
        )
      } else {
        this.props.onChange(
          _.map(this.props.items, 'value')
        )
      }
    }
  }

  handleCheckboxClickMemoizedFunctions = {}
  getMemoizedHandleCheckboxClick = (value) => {
    if (this.handleCheckboxClickMemoizedFunctions[value]) {
      return this.handleCheckboxClickMemoizedFunctions[value]
    }

    return this.handleCheckboxClickMemoizedFunctions[value] = () => {
      this.handleCheckboxClick(value)
    }
  }

  render() {
    if (this.props.loading) {
      return <Loading />
    }

    return (
      <InputGroup
        className={ this.props.className }
        items={ this.props.items }
        hasBaseItem={ this.props.items.length > 0 && this.props.hasBaseItem }
      >
        {(item) => (
          <input
            type="checkbox"
            checked={ this.isValueSelected(item.value) }
            onClick={ this.getMemoizedHandleCheckboxClick(item.value) }
            value={ item.value }
          />
        )}
      </InputGroup>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/molecules/CheckboxGroup/CheckboxGroup.js